// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","headerLink":"headerLink__0YvSg"};